var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createStore } from 'zustand/vanilla';
import WordPressAjaxService from '../components/wordpress-ajax-service';
const CheckoutStore = createStore((set, get) => ({
    api: new WordPressAjaxService(window.perlaData.ajax_url, window.perlaData.checkoutFormNonce),
    isLoading: false,
    steps: {
        form_client_data: {
            el: null,
            formData: {},
        },
        form_delivery: {
            el: null,
            formData: {},
        },
        form_payment: {
            el: null,
            formData: {},
        },
    },
    setApi(api) {
        set({ api });
    },
    updateForm(form, o) {
        const currentState = get();
        const currentFormState = currentState.steps[`${form}`];
        return set(Object.assign(Object.assign({}, currentState), { steps: Object.assign(Object.assign({}, currentState.steps), { [`${form}`]: Object.assign(Object.assign({}, currentFormState), o) }) }));
    },
    sendForm(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return sendForm(id, data);
        });
    },
    getFormIds() {
        return Object.keys(get().steps)
            .map((s) => `#${s}`)
            .join(',');
    },
}));
function sendForm(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { api } = CheckoutStore.getState();
        try {
            const response = yield api.sendRequest('checkout_form', { id, data: JSON.stringify(data) });
            return response;
        }
        catch (error) {
            console.error('Request failed:', error);
        }
        return { success: false, message: 'unknown error' };
    });
}
export { CheckoutStore };
